import txBase, {TO_SAVE_BASE, KEY, initState as baseState} from '../../../vuex/tx-base';
import {registerModule} from '../../../vuex/helpers/vuex-pathify-register-module';
import {sync, make} from 'vuex-pathify'

import deepmerge from "deepmerge";
import templateResetMutation from "../../../vuex/helpers/template-reset-mutation";

const STORE_NAMESPACE = 'lovemap';

function isSet(obj, key) {
    return obj && obj[key] !== typeof undefined
}
let mapData = window[KEY];

export const initState = (mapData) => {

    let mapTitle = isSet(mapData, 'mapTitle') ? mapData.mapTitle : "Tänk att du och jag träffades";
    let firstCity = isSet(mapData, 'firstCity') ? mapData.firstCity : "Stockholm";
    let secondCity = isSet(mapData, 'secondCity') ? mapData.secondCity : "Göteborg";

    return {
        point1: mapData?.point1 || [59.3251172, 18.0710935],
        point2: mapData?.point2 || [57.7072326, 11.9670171],
        center: mapData?.center || [62.101002060735084, 13.690978983216212],
        zoom: mapData?.zoom || 6,
        distance: mapData?.distance || "397 km",
        mapBounds: mapData?.mapBounds || {},
        firstCity,
        firstCityData: mapData?.firstCityData || {},
        secondCity,
        secondCityData: mapData?.secondCityData || {},
        lang: mapData?.lang || "sw",
        mapHearts: mapData?.mapHearts || "ja",
        mapShowDistance: mapData?.mapShowDistance || "ja",
        heartMultiplier: mapData?.heartMultiplier || 1,
        mapTitle,
        mapStyle: mapData?.mapStyle || 'lovemap',
        iconPosition: mapData?.iconPosition || 'center',
        presetSelected: mapData?.presetSelected || false,
        redLine: mapData?.redLine || 'nej',
    }
}


let vuexModule = {};
vuexModule.state = initState(mapData);

vuexModule.mutations = {
    ...make.mutations(vuexModule.state),
    reset: templateResetMutation(initState, STORE_NAMESPACE)
}

const EXCLUDE_FROM_SAVE = ['presetSelected'];

let SAVE_PARAMS = [
    ...TO_SAVE_BASE,
    ...Object.keys(vuexModule.state).filter(item => !!EXCLUDE_FROM_SAVE.findIndex(exclude => item === exclude))
]

let extendedModule = deepmerge(txBase, vuexModule);

function members() {
    const {state} = extendedModule;
    let computed = {};
    for (let [key, value] of Object.entries(state)) {
        computed[key] = sync(`${STORE_NAMESPACE}/${key}`)
    }

    computed.toSaveParams = function () {
        let toSaveParams = {};
        for (let key of SAVE_PARAMS) {
            toSaveParams[key] = this[key]
        }
        return toSaveParams
    };

    return {
        computed,
    }
}

export default LovemapModule => {
    return registerModule(STORE_NAMESPACE, extendedModule, members);
}